import { gameLiveConnection } from '../services/GameConnection';

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    gameLiveConnection?.init().then(() => {
      this.isConnected = true;
      this.connectionInitCallback();
    });
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback(isFirstInit) {
    if (this.isConnected) {
      gameLiveConnection.sendGameGetInitialState(isFirstInit).then(() => {});
    }
  }
}

export const liveConnection = new LiveConnection();
